<template>
  <div class="sms-jump-ad">
    <div class="pact">
      <p class="pact-title">结算说明</p>
      <p class="sub-title">1. 服务费查看及支付规定</p>
      <p class="pact-content">服务商可至“超级教练路考仪服务商”平台上查看服务费明细。服务商每月请按照平台上显示的上一自然月的服务费总额来开具并邮寄发票。我司在收到发票并确认无误后，每个月10号之前将上一自然月的服务费打款至您申请服务商时提供的公司银行账户。如发票延误的，则延期打款。是否打款均可在“超级教练路考仪服务商”平台查询。</p>
      <p class="pact-content">服务费查看路径：我的收入>收入明细>切换年月>查看明细。对于收入总额存在争议的，请及时向我司提出，我司会尽快核实并处理。</p>
      <p class="sub-title">2. 邮寄及开票信息</p>
      <p class="pact-content">服务商需打印结算清单，包括但不限于服务商ID、公司名称、服务城市、联系人、联系人手机号、服务费年月，加盖公章后连同  发票  每月5号之前快递到    上海市闵行区合川路2570号科技绿洲三期2号楼8层  收件人：超级教练路考仪发票管理部  联系电话：021-61278628 或电子发票发送到    lukaoyi@chelun.com   邮箱；发票必须加盖发票专用章；期间因快递发票等事项所产生的运费均由寄件方承担。</p>
      <p class="pact-content">注：</p>
      <p class="pact-content">开票抬头：上海易点时空网络有限公司；</p>
      <p class="pact-content">发票内容请开"服务费"或“推广服务费”；</p>
      <p class="pact-content">寄件不要用胶水粘贴在一起，可用回形针将发票和备注信息纸张别好。</p>
      <p class="pact-content">附：我司开票信息如下：</p>
      <p class="pact-content">1）单位名称：上海易点时空网络有限公司</p>
      <p class="pact-content">2）纳税人识别号：91310112054599258D</p>
      <p class="pact-content">地址、电话：上海市闵行区合川路2570号科技绿洲三期2号楼8层（021）61278600</p>
      <p class="pact-content">4）开户银行及账号：交通银行股份有限公司上海东方路支行 310066988018010034746</p>
    </div>
  </div>
</template>

<script>
const date = new Date()
export default {
  data () {
    return {
      dev: {
        owner_name: '',
        dev_sn: '',
        owner_mobile: ''
      },
      year: date.getFullYear(),
      month: date.getMonth(),
      day: date.getDate()
    }
  },
  created: function () {
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.pact {
  background: #fff;
  font-size: .24rem;
  line-height: 1.6;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 0 .3rem;
  z-index: 999;
  padding-bottom: 20px;
  .pact-title {
    text-align: center;
    font-size: .34rem;
    font-weight: 600;
    line-height: 1rem;
  }
  .sub-title {
    margin-top: 10px;
    font-size: .28rem;
    font-weight: 600;
  }
  .pact-content {
    text-indent: 1em;
  }
  .pact-hint {
    text-align: center;
    margin: 20px auto;
  }
  .footer {
    display: -webkit-flex;
    display: flex;
    span:first-child {
      flex: 3;
    }
    span:last-child {
      flex: 2;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/pactList/settlePact.vue